window.Tooltip = (function () {
    const ERROR_DELAY = 3000;
    var element, content, container, innerContainer;
    var delayTimeout,
        defaultDelay = 2000;
    var isVisible = false;

    const MAIN_ATTR = 'bb-tool',
        DELAY_ATTR = 'bb-tool-delay',
        TYPE_ATTR = 'bb-tool-type',
        TEXT_SELECTOR_ATTR = 'bb-tool-text-selector';

    var Tooltip = function () {
        container = $('<div/>', {
            class: 'tooltip',
        });

        innerContainer = $('<div/>', {
            class: 'tooltip__inner',
        }).appendTo(container);

        container.appendTo('body');

        bindUI();
    };

    var bindUI = function () {
        let attrSelector = '[' + MAIN_ATTR + ']';

        $(document).on('mouseenter', attrSelector, function () {
            element = $(this);
            mouseenterHandler();
        });

        $(document).on('mouseleave', attrSelector, function () {
            hide();
            if (delayTimeout) {
                clearTimeout(delayTimeout);
            }
        });
    };

    var mouseenterHandler = function () {
        var delay;

        if (isVisible) {
            hide();
        }

        content = element[0].hasAttribute(TEXT_SELECTOR_ATTR)
            ? $($(element).attr(TEXT_SELECTOR_ATTR)).html()
            : element.attr(MAIN_ATTR);
        if (content === '') {
            return;
        }

        if (element[0].hasAttribute(DELAY_ATTR)) {
            delay = parseInt(element.attr(DELAY_ATTR));

            if (delay !== 0) {
                delayTimeout = setTimeout(show, delay);
            } else {
                show();
            }
        } else {
            show();
        }

        // dispatch event for Matomo Analytics
        document.dispatchEvent(
            new CustomEvent('showTooltip', {
                detail: {
                    data: content,
                    elem: element,
                },
            })
        );

        element.one('remove', hide);
    };

    var afterContentInsertedAction = function () {
        innerContainer.height('auto');

        container.removeClass('error attention learning success');

        switch (element.attr(TYPE_ATTR)) {
            case 'error':
                container.addClass('error');
                break;
            case 'attention':
                container.addClass('attention');
                break;
            case 'learning':
                container.addClass('learning');
                break;
            case 'success':
                container.addClass('success');
                break;
            case 'wide':
                container.addClass('m-wide');
                break;
            default:
                break;
        }
        container.removeClass('left right top bottom height-limited');
        setPosition();
        isVisible = true;
    };

    var show = function () {
        innerContainer.html(content).promise().done(afterContentInsertedAction);
    };

    var setPosition = function () {
        var elementOffset = element.offset(),
            elementWidth = element.outerWidth(),
            elementHeight = element.outerHeight(),
            tooltipOffset = {
                left: 0,
                top: 0,
            },
            tooltipWidth = container.outerWidth(),
            tooltipHeight = container.outerHeight(),
            windowWidth = $(window).width(),
            windowHeight = $(window).height(),
            positionClassname = 'top';

        // по умолчанию отображается сверху от элемента
        tooltipOffset.left =
            elementOffset.left + elementWidth / 2 - tooltipWidth / 2;
        tooltipOffset.top = elementOffset.top - tooltipHeight - 10;

        // если выходит за верхнюю границу окна - снизу
        if (tooltipOffset.top < 0) {
            tooltipOffset.top = elementOffset.top + elementHeight + 10;
            positionClassname = 'bottom';

            // если и так выходит за границу окна - отображаем сверху, и обрезаем часть содержимого
            // TODO то же самое для случая, когда элемент отображается в верхней части страницы (тултип должен так же обрезаться и располагаться снизу)
            if (tooltipOffset.top + tooltipHeight > windowHeight) {
                var maxHeight = elementOffset.top - elementHeight - 40;

                innerContainer.height(maxHeight);

                tooltipOffset.top = 10;
                positionClassname = 'top height-limited';
            }
        }

        // если выходит за правую границу окна - слева
        if (tooltipOffset.left + tooltipWidth > windowWidth) {
            tooltipOffset.left = elementOffset.left - tooltipWidth - 10;
            tooltipOffset.top =
                elementOffset.top + elementHeight / 2 - tooltipHeight / 2;
            positionClassname = 'left';
        }

        // если выходит за левую границу окна - справа
        if (tooltipOffset.left < 0) {
            tooltipOffset.left = elementOffset.left + elementWidth + 10;
            tooltipOffset.top =
                elementOffset.top + elementHeight / 2 - tooltipHeight / 2;
            positionClassname = 'right';
        }

        container.show();

        container
            .css({
                left: tooltipOffset.left,
                top: tooltipOffset.top,
            })
            .off('transitionend')
            .addClass(positionClassname + ' visible');
    };

    var hide = function () {
        isVisible = false;

        container.removeClass('visible').on('transitionend', function () {
            container.hide();
            container.removeClass('left right top bottom');
        });

        if (typeof element !== 'undefined') {
            element.off('remove');
        }
        $(document).off('touchstart.hideTooltip');
    };

    var update = function (elem) {
        if (elem) mouseenterHandler(elem);
    };

    function destroyConcrete(node) {
        node.removeAttr(MAIN_ATTR).removeAttr(TYPE_ATTR);
        hide();
    }

    function showNode(node, message, type, persistent) {
        if (node === undefined) return false;

        if (!(node instanceof jQuery)) {
            node = $(node);
        }

        node.attr(MAIN_ATTR, message).attr(TYPE_ATTR, type);
        element = node;
        mouseenterHandler(node);
        if (persistent) return true;
        container.addClass('jump').one('animationend', function (e) {
            container.removeClass('jump');
            var destroyTOID = setTimeout(function () {
                destroyConcrete(node);
            }, ERROR_DELAY);
            node.one('mouseleave', function () {
                destroyConcrete(node);
                clearTimeout(destroyTOID);
            });
        });
        return true;
    }

    function errorNode(node, message, persistent) {
        return showNode(node, message, 'error', persistent);
    }

    function successNode(node, message, persistent) {
        return showNode(node, message, 'success', persistent);
    }

    function updateOpenedTooltipText(node, message) {
        if (node === undefined || !isVisible || node[0] !== element[0]) return;
        innerContainer.html(message).promise().done(afterContentInsertedAction);
    }

    $(function () {
        Tooltip();
    });

    return {
        update: update,
        hide: hide,
        errorNode: errorNode,
        successNode: successNode,
        updateOpenedTooltipText: updateOpenedTooltipText,
    };
})();
